import { CorePermissions } from '@/constants/permissions.constant';
import { AllValues } from '@/utils/types/types.util';
import { Permission, PermissionName } from './types/Permission';

export function hasCorePermission(
  chosenPermission: AllValues<typeof CorePermissions>,
  corePermissions: AllValues<typeof CorePermissions>[],
) {
  return corePermissions.includes(chosenPermission);
}

export function hasUserPermission(
  chosenPermission: PermissionName,
  userPermissions: Permission[],
): boolean {
  const permission = userPermissions.find((p) => p.permission_name === chosenPermission);
  if (!permission) return false;
  return permission.active && permission.state === 'assigned';
}

export function permissionIsNotSet(
  chosenPermission: PermissionName,
  userPermissions: Permission[],
) {
  const permission = userPermissions.find((p) => p.permission_name === chosenPermission);
  if (!permission) return false;
  return permission.state === 'not-set';
}
